/**
 * This component renders the sidebar for a club page
 * WARNING - Currently using some dummy data
 */
import React from "react";
import ProfileImageContainer from "../core/ProfileImageContainer";
import { Link } from "react-router-dom";

// TODO sort gradient import here, why is it needed??
const ClubSidebar = ({ gbs, data, gradientStyle }) => {
  return (
    <>
      <div className="sidebar w-full flex flex-col items-center justify-start w-auto xs:m-1 xs:mx-4 pt-4 xs:mb-4 xl:mr-8 xl:px-0 px-2 xxs:px-4">
        <div className="max-w-[800px] w-full">
          <h2 className="text-xl text-center">
            {data.full_name}
          </h2>
          {/* Gradient line */}
          {data.committee ? (
            <div>
              <div className="w-full h-2 mt-2" style={gradientStyle}>
                <p className="hidden">Gradient line</p>
              </div>

              {/* Committee */}
              <div className="flex flex-col justify-center items-center">
                {data.committee.map((member) => (
                  <div className="w-full max-w-[340px] flex mt-4">
                    <Link
                      to={`/player/${member.img}`}
                      className="flex flex-row justify-start items-center group"
                    >
                      <div className="h-16 w-16 mr-2 xs:mr-3 rounded-full bg-white dark:bg-dark-2 flex flex-col justify-center items-center">
                        <ProfileImageContainer
                          player={member.img}
                          club={member.club_id}
                          backup={member.club_name}
                          alt="Player image"
                          extraClasses={"rounded-full"}
                        />
                      </div>
                      <div className="flex flex-col justify-start items-start">
                        <p className="text-center group-hover:text-buiha-red dark:group-hover:text-dark-5 ease-in-out duration-200">
                          {member.name}
                        </p>

                        <p className="text-xs font-light">{member.role}</p>
                        <p className="text-darken text-xxs text-center font-light">{member.subtitle}</p>
                      </div>
                    </Link>
                  </div>
                ))}
              </div>
            </div>
          ) : null}

          {/* Gradient line */}
          {data.institutions && data.institutions.length > 0 ? (
            <>
              <div className="w-full h-2 mt-4" style={gradientStyle}>
                <p className="hidden">Gradient line</p>
              </div>
              <h2 className="text-xl mt-4 mb-2 text-center xl:text-left">
                Key Institutions
              </h2>
              {data.institutions.map((institution) => (
                <p className="max-xs:text-xs max-xs:leading-tight text-center font-light xl:text-left">{institution.uni}</p>
              ))}
            </>
          ) : null}

          {data.training && data.training.length > 0 ? (
            <>
              <div className="w-full h-2 mt-4" style={gradientStyle}>
                <p className="hidden">Gradient line</p>
              </div>
              <h2 className="text-xl mt-4 mb-2 text-center xl:text-left">
                Training Times
              </h2>
              {data.training.map((date) => (
                <p className="max-xs:text-xs max-xs:leading-tight font-light text-center xl:text-left">
                  {date[0]} {date[1]}
                </p>
              ))}
            </>
          ) : null}

          {data.training || data.club_address ? (
            <div className="w-full h-2 mt-4" style={gradientStyle}>
              <p className="hidden">Gradient line</p>
            </div>
          ) : null}

          {data.rink_address && data.rink_address.length > 0 ? (
            <>
              <h2 className="text-xl mt-4 mb-2 text-center xl:text-left">
                Rink Address
              </h2>
              {data.rink_address.map((line) => (
                <p className="text-center max-xs:text-xs max-xs:leading-tight font-light xl:text-left max-xl:px-2">{line}</p>
              ))}
            </>
          ) : null}

          {data.club_address && data.club_address.length > 0 ? (
            <>
              <h2 className="text-xl mt-4 mb-2 text-center xl:text-left">
                Club Address
              </h2>
              {data.club_address.map((line) => (
                <p className="text-center max-xs:text-xs max-xs:leading-tight xl:text-left font-light max-xl:px-2">{line}</p>
              ))}
            </>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default ClubSidebar;
